import EntryActionTypes from '../constants/EntryActionTypes';

const inviteOrganizationMember = (organizationId, data) => ({
  type: EntryActionTypes.ORGANIZATION_MEMBER_INVITE,
  payload: {
    organizationId,
    data,
  },
});

const syncOrganizationFromClerk = (organizationId) => ({
  type: EntryActionTypes.ORGANIZATION_FROM_CLERK_SYNC,
  payload: {
    organizationId,
  },
});

const removeOrganizationMember = (organizationId, userId) => ({
  type: EntryActionTypes.ORGANIZATION_MEMBER_REMOVE,
  payload: {
    organizationId,
    userId,
  },
});

const handleOrganizationMembershipDelete = (organizationId, userId) => ({
  type: EntryActionTypes.ORGANIZATION_MEMBERSHIP_DELETE_HANDLE,
  payload: {
    organizationId,
    userId,
  },
});

export default {
  inviteOrganizationMember,
  syncOrganizationFromClerk,
  removeOrganizationMember,
  handleOrganizationMembershipDelete,
};
